// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"75284068","129":"6e01da4f","145":"39d7b6b7","429":"298438bb","585":"b414f1be","602":"0d77677d","631":"298438bb","823":"83899822","934":"873ff6d8"}[chunkId] + ".chunk.css";
};